class FileInput {
  constructor($el) {
    if (!this.setVars($el)) return;

    this.setEvents();
    this.updateState();
  }

  setVars($el) {
    this.$el = $el;
    if (!this.$el) return false;

    this.$input = this.$el.querySelector('.file-input__input');
    if (!this.$input) return false;

    this.$items = this.$el.querySelector('.file-input__items');
    this.$itemTpl = this.$items.querySelector('.file-input__item');
    this.$items.removeChild(this.$itemTpl);

    this.isMultiple = this.$input.getAttribute('multiple') !== null;

    this.classes = {
      highlight: 'file-input--highlight',
      itemsHidden: 'file-input__items--hidden',
    };

    this.aria = JSON.parse(this.$el.getAttribute('data-file-input-aria') || '{}');

    this.filesBuffer = new DataTransfer();

    return true;
  }

  setEvents() {
    this.onChange = this.onChange.bind(this);
    this.onDragEnter = this.onDragEnter.bind(this);
    this.onDragLeave = this.onDragLeave.bind(this);
    this.onDrop = this.onDrop.bind(this);
    this.onRemoveClick = this.onRemoveClick.bind(this);

    this.$input.addEventListener('change', this.onChange);
    this.$input.addEventListener('dragenter', this.onDragEnter);
    this.$input.addEventListener('dragleave', this.onDragLeave);

    document.addEventListener('drop', this.onDrop);
  }

  onChange() {
    const toRemoveIdsArr = [];

    if (!this.isMultiple) {
      const $prevItems = this.$items.querySelectorAll('[data-file-input-item-id]');

      $prevItems.forEach(($item) => {
        this.$items.removeChild($item);

        toRemoveIdsArr.push($item.getAttribute('data-file-input-item-id'));
      });
    }

    this.updateFilesBuffer(this.$input.files, toRemoveIdsArr);
  }

  onDragEnter(e) {
    if (e.target === e.relatedTarget) return;

    this.setHightlight(true);
  }

  onDragLeave(e) {
    if (e.target === e.relatedTarget) return;

    this.setHightlight(false);
  }

  onDrop(e) {
    const $input = e.target.closest('.file-input__input');
    if ($input !== this.$input) return;

    this.setHightlight(false);

    // prevent default action (open as link for some elements)
    // e.preventDefault();
  }

  updateFilesBuffer(newFilesArr = [], toRemoveIdsArr = []) {
    const prevFilesBuffer = this.filesBuffer;
    const nextFilesBuffer = new DataTransfer();

    const fileIdsArr = [];

    FileInput.eachFile(prevFilesBuffer.files, (file) => {
      const fileId = FileInput.getFileId(file);
      if (fileIdsArr.includes(fileId)) return true;

      if (toRemoveIdsArr.includes(fileId)) return true;

      nextFilesBuffer.items.add(file);
      fileIdsArr.push(fileId);

      return true;
    });

    FileInput.eachFile(newFilesArr, (file) => {
      const fileId = FileInput.getFileId(file);
      if (fileIdsArr.includes(fileId)) return true;

      this.appendFileItem(file, fileId);

      nextFilesBuffer.items.add(file);
      fileIdsArr.push(fileId);

      return true;
    });

    this.$input.files = nextFilesBuffer.files; // it causes problem on firefox

    const fileNamesArr = [];
    // this.filesBuffer = nextFilesBuffer; // not works in firefox (uses ref)
    this.filesBuffer = new DataTransfer(); // create new one to prevent using ref
    FileInput.eachFile(this.$input.files, (file) => {
      this.filesBuffer.items.add(file);
      fileNamesArr.push(file.name);
    });

    const inputAriaLabel = `${this.aria.selected}: ${(
      fileNamesArr.length > 0 ? fileNamesArr.join(', ') : this.aria.noFile
    )}`;
    FileInput.setAriaLabel(this.$input, inputAriaLabel);

    this.updateState();
  }

  appendFileItem(file, fileId) {
    if (file === undefined) return;

    const $itemTplClone = this.$itemTpl.cloneNode(true);
    const $removeButton = $itemTplClone.querySelector('.file-input__item-remove');
    const $name = $itemTplClone.querySelector('.file-input__item-name');
    const $size = $itemTplClone.querySelector('.file-input__item-size');

    $name.innerHTML = file.name;
    $size.innerHTML = FileInput.formatSize(file.size);

    $itemTplClone.setAttribute('data-file-input-item-id', fileId);

    $removeButton.addEventListener('click', this.onRemoveClick);

    FileInput.setAriaLabel($removeButton, `${this.aria.remove} ${file.name}`);

    this.$items.appendChild($itemTplClone);
  }

  static setAriaLabel($el, label) {
    $el.setAttribute('aria-label', label);
  }

  static eachFile(files, callback) {
    const l = files.length;
    for (let i = 0; i < l; i += 1) {
      const result = callback(files[i]);
      if (result === false) break;
      // if (result === true) continue;
    }
  }

  static getFileId(file) {
    return `${file.size}-${file.name}`;
  }

  setHightlight(highlight) {
    if (highlight) {
      this.$el.classList.add(this.classes.highlight);
    } else {
      this.$el.classList.remove(this.classes.highlight);
    }
  }

  setListVisibility(visible) {
    if (visible) {
      this.$items.classList.remove(this.classes.itemsHidden);
    } else {
      this.$items.classList.add(this.classes.itemsHidden);
    }
  }

  onRemoveClick(e) {
    const $clickedItem = e.currentTarget.closest('.file-input__item');

    this.$items.removeChild($clickedItem);

    this.updateFilesBuffer([], [$clickedItem.getAttribute('data-file-input-item-id')]);
    this.$input.focus();
  }

  updateState() {
    this.setListVisibility(this.$items.children.length > 0);
  }

  static formatSize(bytes, decimals = 2) {
    const base = 1024;

    if (bytes === 0) return '0 B';

    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ['B', 'KB', 'MB', 'GB'];

    const i = Math.floor(Math.log(bytes) / Math.log(base));

    return `${parseFloat((bytes / (base ** i)).toFixed(dm))} ${sizes[i]}`;
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.js-file-input').forEach(
    $fileInput => new FileInput($fileInput),
  );
});
